// @ts-nocheck


import React, { useCallback } from 'react';

import { FilterItem } from '../../../components';
import Field from '../../../components/card/Field';
import {
  CommonFilter } from

'../../../components/hoc/common/handbook/CommonFilter';

import WashingVehicleTypeSelect from '../../../components/selects/WashingVehicleTypeSelect';





export const WashingFrequencyFilter = (
props) =>
{
  const Filter = useCallback(
    (filterProps) =>
    CommonFilter({
      ...filterProps,
      ...props
    }),
    [props]
  );
  return (
    <Filter>
      {(values, changeValue) =>
      <>
          <FilterItem>
            <Field mBottomNone>
              <WashingVehicleTypeSelect
              size="small"
              value={values.orgUnitId}
              onChange={(value) => changeValue('vehicleType.id', value)} />

            </Field>
          </FilterItem>
        </>
      }
    </Filter>);

};
export default WashingFrequencyFilter;
